import randomId from "../common/randomId";
import Accounting from "../views/Accounting/Accounting";
import EmailPasswordReset from "../views/Auth/EmailPasswordReset";
import Activity from "../views/Activity/Activity";
import AiAssistant from "../views/AiAssistant"
import Orders from "../views/Orders/Orders"
import StoreProfilePage from "../views/Stores/StoreProfilePage";
import Login from "../views/Auth/Login";
import Register from "../views/Auth/Register";
import StaffPasswordSetup from "../views/Auth/StaffPasswordSetup";
import Clients from "../views/Clients/Clients";
import Campaigns from "../views/Campaigns/Campaigns";
import FashionComingSoon from "../views/ComingSoon/FashionComingSoon";
import Debtors from "../views/Debtors/Debtors";
import EcommerceRequest from "../views/Ecommerce/EcommerceRequest";
import Expenses from "../views/Expenses/Expenses";
import Models from "../views/Models/Models";
import Phones from "../views/Phones/Phones";
import Profile from "../views/Profile/Profile";
import Reports from "../views/Reports/Reports";
import Sales from "../views/Sales/Sales";
import CollectPaymentPage from "../views/Sales/CollectPaymentPage";
import SaleStudioPage from "../views/Sales/SaleStudioPage";
import AddProductPage from "../views/Stock/AddProductPage";
import Settings from "../views/Settings/Settings";
import Stock from "../views/Stock/Stock";
import Stores from "../views/Stores/Stores";
import Suppliers from "../views/Suppliers/Suppliers";
import Users from "../views/Users/UsersView";
import Dashboard from "../views/Dashboard/Dashboard";
import ServiceShowcasePage from "../views/ServiceStorefront/ServiceShowcasePage";
import ServiceReviewsPage from "../views/ServiceStorefront/ServiceReviewsPage";

const viewsUrls: any[] = [
    { id: randomId(), path: "/accounting", exact: true, component: Accounting, type: "private" },
    { id: randomId(), path: "/reset-password", exact: true, component: EmailPasswordReset, type: "public" },
    {
        id: randomId(),
        path: "/",
        exact: true,
        component: Login,
        type: "public"
    },
    {
        id: randomId(),
        path: "/login",
        exact: true,
        component: Login,
        type: "public"
    },
    {
        id: randomId(),
        path: "/register",
        exact: true,
        component: Register,
        type: "public"
    },
    {
        id: randomId(),
        path: "/activate-account",
        exact: true,
        component: StaffPasswordSetup,
        type: "public"
    },
    {
        id: randomId(),
        path: "/set-password",
        exact: true,
        component: StaffPasswordSetup,
        type: "public"
    },
    {
        id: randomId(),
        path: "/gestock/set-password",
        exact: true,
        component: StaffPasswordSetup,
        type: "public"
    },
    {
        id: randomId(),
        path: "/dashboard",
        exact: true,
        component: Dashboard,
        type: "private"
    },
    {
        id: randomId(),
        path: "/store/profile",
        exact: true,
        component: StoreProfilePage,
        type: "private"
    },
    {
        id: randomId(),
        path: "/orders",
        exact: true,
        component: Orders,
        type: "private"
    },
    {
        id: randomId(),
        path: "/ai-assistant",
        exact: true,
        component: AiAssistant,
        type: "private"
    },
    {
        id: randomId(),
        path: "/phones",
        exact: true,
        component: Phones,
        type: "private"
    },
    {
        id: randomId(),
        path: "/stock",
        exact: true,
        component: Stock,
        type: "private"
    },
    {
        id: randomId(),
        path: "/stock/new",
        exact: true,
        component: AddProductPage,
        type: "private"
    },
    {
        id: randomId(),
        path: "/models",
        exact: true,
        component: Models,
        type: "private"
    },
    {
        id: randomId(),
        path: "/sales",
        exact: true,
        component: Sales,
        type: "private"
    },
    {
        id: randomId(),
        path: "/sales/new",
        exact: true,
        component: SaleStudioPage,
        type: "private"
    },
    {
        id: randomId(),
        path: "/sales/collect",
        exact: true,
        component: CollectPaymentPage,
        type: "private"
    },
    {
        id: randomId(),
        path: "/clients",
        exact: true,
        component: Clients,
        type: "private"
    },
    {
        id: randomId(),
        path: "/campaigns",
        exact: true,
        component: Campaigns,
        type: "private"
    },
    {
        id: randomId(),
        path: "/debtors",
        exact: true,
        component: Debtors,
        type: "private"
    },
    {
        id: randomId(),
        path: "/expenses",
        exact: true,
        component: Expenses,
        type: "private"
    },
    {
        id: randomId(),
        path: "/reports",
        exact: true,
        component: Reports,
        type: "private"
    },
    {
        id: randomId(),
        path: "/users",
        exact: true,
        component: Users,
        type: "private"
    },
    {
        id: randomId(),
        path: "/activity",
        exact: true,
        component: Activity,
        type: "private"
    },
    {
        id: randomId(),
        path: "/stores",
        exact: true,
        component: Stores,
        type: "private"
    },
    {
        id: randomId(),
        path: "/suppliers",
        exact: true,
        component: Suppliers,
        type: "private"
    },
    {
        id: randomId(),
        path: "/service-showcase",
        exact: true,
        component: ServiceShowcasePage,
        type: "private"
    },
    {
        id: randomId(),
        path: "/service-reviews",
        exact: true,
        component: ServiceReviewsPage,
        type: "private"
    },
    {
        id: randomId(),
        path: "/profile",
        exact: true,
        component: Profile,
        type: "private"
    },
    {
        id: randomId(),
        path: "/settings",
        exact: true,
        component: Settings,
        type: "private"
    },
    {
        id: randomId(),
        path: "/ecommerce-request",
        exact: true,
        component: EcommerceRequest,
        type: "private"
    }, {
        id: randomId(),
        path: "/fashion-coming-soon",
        exact: true,
        component: FashionComingSoon,
        type: "private"
    }
];

export default viewsUrls;
